import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import getStorage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCKKa9UzO18dGFuCvq8xZQ8FNgQQQ-XSqQ",
  authDomain: "cfe-social-platform.firebaseapp.com",
  projectId: "cfe-social-platform",
  storageBucket: "cfe-social-platform.appspot.com", // Corrected storage bucket
  messagingSenderId: "591102643955",
  appId: "1:591102643955:web:7defd018abf71c83b8f186"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize storage

export { auth, db, storage }; // Export storage